import React from "react"
import PropTypes from "prop-types"
import { getCompiler } from "utils/MarkdownCompile"

const elements = {
  h1({ id, children }) {
    return <h1 className="publico-headline b normal lh-title mt5 black-90">{children}</h1>
  },
  h2({ id, children }) {
    return <h2 className="publico-headline b normal lh-title mt5 black-90">{children}</h2>
  },
  h3({ id, children }) {
    return <h3 className="publico-headline b normal lh-title mt5 black-90">{children}</h3>
  },
  h4({ id, children }) {
    return <h4 className="publico-headline b normal lh-title mt5 black-90">{children}</h4>
  },
  hr({ id, children }) {
    return <hr className="w-100 center b--black-10" />
  },
  li({ children }) {
    return <li className="lh-copy mv3">{children}</li>
  },
  ol({ children }) {
    return <ol className="lh-copy mv3 pl3">{children}</ol>
  },
  ul({ children }) {
    return (
      <ul className="lh-copy mv3 mr2 carrot-orange">
        <span className="black-80">{children}</span>
      </ul>
    )
  },

  p({ children }) {
    return <p className="lh-copy mv3">{children}</p>
  },

  // we want to disable links in FLE per legal
  a({ children }) {
    return <span className="no-underline black-90">{children}</span>
  },

  strong({ children }) {
    return <strong style={{ fontWeight: 500 }}>{children}</strong>
  }
}

const md = getCompiler(elements)

const FLEInformationModalMarkdown = ({ additionalClasses, source }) => (
  <div className={`m0-first-last-child ${additionalClasses ? additionalClasses : ""}`}>{md(source)}</div>
)

FLEInformationModalMarkdown.propTypes = {
  source: PropTypes.string.isRequired,
  additionalClasses: PropTypes.string
}
export { elements }

export default FLEInformationModalMarkdown
